export default __webpack_public_path__ + "static/media/IMG_0471-2.af6868a5.jpg";